// @flow

import * as Recompose        from 'recompose';
import Button                from '../../../modules/reactstrap/components/Button';
import logProps              from '../../HOC/debugging/logProps';
import mapUserCookieSettings from './hocs/mapUserCookieSettings';


// -----------------------------------------------------------------------------------------------------------------
// Main component
// -----------------------------------------------------------------------------------------------------------------


export type AcceptAllCookiesButtonProps = {|
  onClick?: () => void,
|};

const AcceptAllCookiesButton: React.ComponentType<AcceptAllCookiesButtonProps> = Recompose.compose(
  mapUserCookieSettings,

  // $FlowFixMe
  Recompose.mapProps(
    ({color, children, cookieSettings_acceptAll, onClick}) => ({
      color:    color || 'primary',
      children: children || 'Accept all',
      onClick:  (event) => {
        cookieSettings_acceptAll();
        // If we have an onClick then call it as well
        onClick && onClick(event);
      },
    }),
  ),
)(Button);


// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default AcceptAllCookiesButton;



// WEBPACK FOOTER //
// ./src/components/profile/cookies/AcceptAllCookiesButton.js